(function () {
  const AUTOPLAY_INTERVAL = 5000;

  const DEFAULT_OPTIONS = {
    cellAlign: 'center',
    contain: true,
    groupCells: false,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    adaptiveHeight: true,
    percentPosition: false,
    pauseAutoPlayOnHover: true,
  };

  function setupControls(el, flkty) {
    const section = el.closest('[data-featured-reviews]');
    if (!section) return;

    const prevButton = section.querySelector('.featured-reviews__prev');
    const nextButton = section.querySelector('.featured-reviews__next');
    const dotsContainer = section.querySelector('.featured-reviews__dots');

    if (!prevButton || !nextButton || !dotsContainer) return;

    if (el.controlHandlers) {
      prevButton.removeEventListener('click', el.controlHandlers.prev);
      nextButton.removeEventListener('click', el.controlHandlers.next);
      flkty.off('select', el.controlHandlers.update);
    }

    function updateControls() {
      const slideCount = flkty.slides.length;
      const disableNav = slideCount <= 1;

      prevButton.disabled = disableNav;
      nextButton.disabled = disableNav;

      dotsContainer.innerHTML = '';
      flkty.slides.forEach((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'featured-reviews__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.setAttribute('aria-selected', index === flkty.selectedIndex ? 'true' : 'false');
        if (index === flkty.selectedIndex) {
          dot.classList.add('is-selected');
        }
        dot.addEventListener('click', () => flkty.select(index));
        dotsContainer.appendChild(dot);
      });
    }

    const prevHandler = () => flkty.previous();
    const nextHandler = () => flkty.next();

    prevButton.addEventListener('click', prevHandler);
    nextButton.addEventListener('click', nextHandler);
    flkty.on('select', updateControls);
    updateControls();

    el.controlHandlers = {
      prev: prevHandler,
      next: nextHandler,
      update: updateControls,
    };
  }

  function initFeaturedReviewsCarousel(el) {
    if (!el || typeof Flickity === 'undefined') return;

    if (el.flickityInstance) {
      el.flickityInstance.destroy();
      el.flickityInstance = null;
    }

    const section = el.closest('[data-featured-reviews]');
    const autoplayEnabled = section?.dataset.autoplay === 'true';

    let options = { ...DEFAULT_OPTIONS };
    if (el.dataset.flickityOptions) {
      try {
        options = { ...options, ...JSON.parse(el.dataset.flickityOptions) };
      } catch (error) {
        console.warn('Featured reviews: invalid Flickity options', error);
      }
    }

    if (autoplayEnabled) {
      options.autoPlay = AUTOPLAY_INTERVAL;
    }

    const flkty = new Flickity(el, options);
    el.flickityInstance = flkty;
    setupControls(el, flkty);
  }

  function initFeaturedReviews(root = document) {
    root.querySelectorAll('[data-featured-reviews-carousel]').forEach(initFeaturedReviewsCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFeaturedReviews());
  } else {
    initFeaturedReviews();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFeaturedReviews(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-featured-reviews-carousel]').forEach((el) => {
      if (el.flickityInstance) {
        el.flickityInstance.destroy();
        el.flickityInstance = null;
      }
      el.controlHandlers = null;
    });
  });
})();
